<template>
    <GenericCard
        color="white"
        :to="{
            name: 'address-all',
            params: {
                filters: { statusFilter: 'requested', webformFilter: false, initialQuery: '' },
            },
        }"
    >
        <v-card-text>
            <p class="card-title">
                <KpIcon icon-cls="world" color="black" /> {{ $t('neuanmeldungen_kulturplatz') }}
                <v-chip small>{{ counter }}</v-chip>
            </p>
            <p>
                <KpIcon icon-cls="arrow-bigright" color="grey" />
                {{ $t('to_new_kulturplatz') }}
            </p>
        </v-card-text>
    </GenericCard>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import GenericCard from './GenericCard.vue';
import { instance as api } from '@/helpers/api';

const counter = ref(0);

onMounted(async () => {
    try {
        const res = await api().get('/Address/countRegistered');
        if (res?.data?.count) {
            counter.value = Number(res.data.count);
        } else {
            counter.value = 0;
        }
    } catch (e) {
        counter.value = 0;
    }
});
</script>

<style lang="scss" scoped>
.v-chip {
    cursor: pointer;
}
</style>
